export const lookup = [
  {
    credit: [
      {
        cMax: '801',
        cMin: '760',
        pmiMonth: 0.0019,
      },
      {
        cMax: '759',
        cMin: '740',
        pmiMonth: 0.002,
      },
      {
        cMax: '739',
        cMin: '720',
        pmiMonth: 0.0023,
      },
      {
        cMax: '719',
        cMin: '700',
        pmiMonth: 0.0025,
      },
      {
        cMax: '699',
        cMin: '680',
        pmiMonth: 0.0028,
      },
      {
        cMax: '679',
        cMin: '660',
        pmiMonth: 0.0038,
      },
      {
        cMax: '659',
        cMin: '640',
        pmiMonth: 0.004,
      },
      {
        cMax: '639',
        cMin: '620',
        pmiMonth: 0.0044,
      },
      {
        cMax: '619',
        cMin: '600',
        pmiMonth: 0.0066,
      },
    ],
    downMax: 0.1999,
    downMin: 0.15,
    ltv: '85%-80.01',
  },
  {
    credit: [
      {
        cMax: '801',
        cMin: '760',
        pmiMonth: 0.0028,
      },
      {
        cMax: '759',
        cMin: '740',
        pmiMonth: 0.0038,
      },
      {
        cMax: '739',
        cMin: '720',
        pmiMonth: 0.0046,
      },
      {
        cMax: '719',
        cMin: '700',
        pmiMonth: 0.0055,
      },
      {
        cMax: '699',
        cMin: '680',
        pmiMonth: 0.0065,
      },
      {
        cMax: '679',
        cMin: '660',
        pmiMonth: 0.009,
      },
      {
        cMax: '659',
        cMin: '640',
        pmiMonth: 0.0091,
      },
      {
        cMax: '639',
        cMin: '620',
        pmiMonth: 0.0094,
      },
      {
        cMax: '619',
        cMin: '600',
        pmiMonth: 0.014,
      },
    ],
    downMax: 0.1499,
    downMin: 0.1,
    ltv: '90%-85.01%',
  },
  {
    credit: [
      {
        cMax: '801',
        cMin: '760',
        pmiMonth: 0.0038,
      },
      {
        cMax: '759',
        cMin: '740',
        pmiMonth: 0.0053,
      },
      {
        cMax: '739',
        cMin: '720',
        pmiMonth: 0.0066,
      },
      {
        cMax: '719',
        cMin: '700',
        pmiMonth: 0.0078,
      },
      {
        cMax: '699',
        cMin: '680',
        pmiMonth: 0.0096,
      },
      {
        cMax: '679',
        cMin: '660',
        pmiMonth: 0.0128,
      },
      {
        cMax: '659',
        cMin: '640',
        pmiMonth: 0.0133,
      },
      {
        cMax: '639',
        cMin: '620',
        pmiMonth: 0.0142,
      },
      {
        cMax: '619',
        cMin: '600',
        pmiMonth: 0.0212,
      },
    ],
    downMax: 0.0999,
    downMin: 0.05,
    ltv: '95%-90.01%',
  },
  {
    credit: [
      {
        cMax: '801',
        cMin: '760',
        pmiMonth: 0.0058,
      },
      {
        cMax: '759',
        cMin: '740',
        pmiMonth: 0.007,
      },
      {
        cMax: '739',
        cMin: '720',
        pmiMonth: 0.0087,
      },
      {
        cMax: '719',
        cMin: '700',
        pmiMonth: 0.0099,
      },
      {
        cMax: '699',
        cMin: '680',
        pmiMonth: 0.0121,
      },
      {
        cMax: '679',
        cMin: '660',
        pmiMonth: 0.0154,
      },
      {
        cMax: '659',
        cMin: '640',
        pmiMonth: 0.0165,
      },
      {
        cMax: '639',
        cMin: '620',
        pmiMonth: 0.0186,
      },
      {
        cMax: '619',
        cMin: '600',
        pmiMonth: 0.0277,
      },
    ],
    downMax: 0.0499,
    downMin: 0.03,
    ltv: '97-95.01',
  },
];
